import React from 'react';
import { Col, Row } from 'reactstrap';

import CircularLoading from '../../Common/CircularLoading/CircularLoading';
import ScoringHistoryChart from './scoringHistoryChart.jsx';

const MONTH_MAPPER = {
  0: 'Jan',
  1: 'Feb',
  2: 'Mar',
  3: 'Apr',
  4: 'May',
  5: 'June',
  6: 'July',
  7: 'Aug',
  8: 'Sept',
  9: 'Oct',
  10: 'Nov',
  11: 'Dec',
};

class ScoringHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      weeks: null,
      currentWeek: 0,
    };
  }

  componentDidMount() {
    let startLastWeek = new Date();
    while (startLastWeek.getDay() !== 1) {
      startLastWeek = new Date(startLastWeek.getTime() - 86400000);
    }
    startLastWeek = new Date(
      startLastWeek.getFullYear(),
      startLastWeek.getMonth(),
      startLastWeek.getDate(),
    );
    this.props.loadScoringHistory(startLastWeek.getTime());
    if (this.props.scoringHistory.average) this.getWeeks();
  }

  goNextWeek = () => {
    if (this.state.currentWeek > 0) {
      this.props.loadScoringHistory(
        this.state.weeks[this.state.currentWeek - 1].timeStart,
      );
      this.setState({ currentWeek: this.state.currentWeek - 1 });
    }
  };

  goPreviusWeek = () => {
    if (
      this.state.weeks === null &&
      this.props.userCreatedAt &&
      this.props.userCreatedAt != null
    ) {
      this.getWeeks();
    }

    if (
      this.state.weeks &&
      this.state.currentWeek < this.state.weeks.length - 1
    ) {
      this.props.loadScoringHistory(
        this.state.weeks[this.state.currentWeek + 1].timeStart,
      );
      this.setState({ currentWeek: this.state.currentWeek + 1 });
    }
  };

  getWeeks = () => {
    let startLastWeek = new Date();
    while (startLastWeek.getDay() !== 1) {
      startLastWeek = new Date(startLastWeek.getTime() - 86400000);
    }
    startLastWeek = new Date(
      startLastWeek.getFullYear(),
      startLastWeek.getMonth(),
      startLastWeek.getDate(),
    );
    let startFirstWeek = new Date(this.props.userCreatedAt);
    while (startFirstWeek.getDay() !== 1) {
      startFirstWeek = new Date(startFirstWeek.getTime() - 86400000);
    }
    startFirstWeek = new Date(
      startFirstWeek.getFullYear(),
      startFirstWeek.getMonth(),
      startFirstWeek.getDate(),
    );
    const weeks = [];
    let startWeek = startLastWeek;
    while (startWeek >= startFirstWeek) {
      const endWeek = new Date(startWeek.getTime() + 518400000);
      const weekInformation = {
        timeStart: startWeek.getTime(),
        timeEnd: endWeek.getTime(),
        label: `${
          MONTH_MAPPER[startWeek.getMonth()]
        } ${startWeek.getDate()} - ${
          MONTH_MAPPER[endWeek.getMonth()]
        } ${endWeek.getDate()}`,
      };
      weeks.push(weekInformation);
      startWeek = new Date(startWeek.getTime() - 604800000);
    }
    this.setState({ weeks });
    this.forceUpdate();
  };

  componentDidUpdate() {
    if (
      this.state.weeks === null &&
      this.props.userCreatedAt &&
      this.props.userCreatedAt != null
    ) {
      this.getWeeks();
    }
  }

  render() {
    return (
      <div className="storing-history-container">
        <Row className="m-0">
          <Col xs={6} className="p-0">
            <h5 className="title">Scoring History</h5>
          </Col>
          <Col xs={6} className="p-0">
            <div className="week-selector">
              <i
                onClick={this.goPreviusWeek}
                className={
                  this.state.weeks != null &&
                  this.state.currentWeek < this.state.weeks.length - 1
                    ? 'icon-chevron_left select-icon icon-enabled'
                    : 'icon-chevron_left select-icon icon-disabled'
                }
              />
              <span className="selector-label">
                {this.state.weeks != null &&
                this.state.weeks[this.state.currentWeek] &&
                this.state.weeks[this.state.currentWeek].label
                  ? this.state.weeks[this.state.currentWeek].label
                  : '-'}
              </span>
              <i
                onClick={this.goNextWeek}
                className={
                  this.state.weeks != null && this.state.currentWeek > 0
                    ? 'icon-chevron_right select-icon icon-enabled'
                    : 'icon-chevron_right select-icon icon-disabled'
                }
              />
            </div>
          </Col>
        </Row>
        <Row className="m-0">
          <Col xs={12} className="p-0">
            {this.props.loading ? (
              <div className="d-flex">
                <CircularLoading className="mx-auto loading-resource-gif" />
              </div>
            ) : (
              <ScoringHistoryChart
                weekScore={this.props.scoringHistory.weekPoints}
                average={this.props.scoringHistory.average}
              />
            )}
          </Col>
        </Row>
      </div>
    );
  }
}
export default ScoringHistory;
